import React from 'react';
import BaseAbstract from './BaseAbstract';
import BasePopup from '../Base/Popup';
import style from '@src/js/Style';

export default class Popup extends BaseAbstract {

    constructor(props) {

        super(props);

        this.components = {
            popup: React.createRef(),
        };
    }

    setValue(value) {

        if (typeof(value) == 'string' && value != '')
            value = JSON.parse(value);

        super.setValue(value);
    }

    renderValue() {

        return (
            <>
                <BasePopup ref={ this.components.popup }>{ this.state.value?.text }</BasePopup>

                <a className={ style('underline text-small') } onClick={ (e) => this.click(e) } href="#">
                    { this.state.value?.label }
                </a>
            </>
        );
    }

    click(e) {

        e.preventDefault();
        this.components.popup.current.show();
    }

}